// Reader for VITE_* values that a Dockerfile bakes as `__VITE_X__` placeholders and the container's
// docker-entrypoint.sh replaces with sed at start. If the replacement never ran (or ran with an
// empty value), the bundle still holds the literal placeholder, which `??` does NOT catch. This
// treats undefined, empty and the placeholder itself as unset.
//
// Call sites pass the env object themselves: `readViteEnv(import.meta.env, 'VITE_X', fallback)`.
// Vite only substitutes the literal `import.meta.env` expression at build time, and this package
// has no Vite types, so the helper cannot reach import.meta on its own.
// Enforced by scripts/config-fallback-guard-vite-reads.test.ts (see docs/CONFIG-FALLBACK-GUARD.md).

const PLACEHOLDER = /^__VITE_[A-Z0-9_]+__$/

export function readViteEnv(env: unknown, name: string, fallback: string): string {
  if (typeof env !== 'object' || env === null) return fallback
  const raw: unknown = (env as Record<string, unknown>)[name]
  const value = typeof raw === 'string' ? raw.trim() : ''
  if (value === '' || PLACEHOLDER.test(value)) return fallback
  return value
}
